import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';

import { Text, View } from '@applane/react-core-components';
import Calender from '../../AppraisalResult/Calender';
import { ftsThemeMD } from '../../../theme/ftsTheme';
import vars from '../../../theme/vars';
import ViewButtonsLists from '../../AppraisalResult/ViewButtonsLists';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { Menu, MenuItem } from '@mui/material';
import '../../../screens/AppraisalResult/Calender.css';
import { modifyDateView } from '../../../Lib/helpers';
import { invoke, getUser } from '../../../AppServices';
import { MODELS } from '../../../Lib/constants';

export default function Test1() {
  const [data, setData] = useState([]);
  const [value, setValue] = useState([null, null]);
  const [inputValue, setInputValue] = useState('');
  const [id, setId] = useState('');
  const [view, setView] = useState(false);
  const isRender = useRef(true);
  const dataLength = useRef(data.length);
  const delayTimeout = useRef(null);
  const tableContainerRef = useRef < HTMLDivElement > null;
  const [dataFound, setDataFound] = useState(null);
  let isFirstRender = true;
  const [filteredRows, setFilteredRows] = useState(data || []);
  const fetchMoreOnBottomReached = useCallback(async (containerRefElement) => {
    if (containerRefElement) {
      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      if (scrollHeight - scrollTop - clientHeight < 1) {
        await fetch();
      }
    }
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); // Track the current page
  const pageSize = 20; // Number of items per page

  const user = getUser();
  const userRole = user?.role?.code;

  const fetch = async () => {
    setIsLoading(true);
    console.log('datas', data);
    try {
      let limit, skip;
      let filter = {
        $or: [
          {
            cdk: {
              name: {
                $regex: inputValue,
                $options: 'i',
              },
            },
          },
          {
            cdk: {
              email: {
                $regex: inputValue,
                $options: 'i',
              },
            },
          },
          {
            cdk: {
              vin: {
                $regex: inputValue,
                $options: 'i',
              },
            },
          },
        ],
      };

      // Add dealer filter based on user role
      // if (userRole === 'dealer' || userRole === 'employee' || userRole === 'manager') {
      //   filter = {
      //     ...filter,
      //     name: user.dealer.username,

      //   };
      // }

      limit = 20;
      skip = currentPage * limit;
      await fetchData(limit, skip, filter);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async (limit, skip, filter) => {
    if (value[0] && value[1]) {
      const startDate = new Date(value[0]);
      startDate.setUTCHours(startDate.getUTCHours() + 5); // Adjust to UTC+5:00
      const endDate = new Date(value[1]);
      endDate.setUTCHours(endDate.getUTCHours() + 5); // Adjust to UTC+5:00

      const startDateISOString = startDate.toISOString();
      const endDateISOString = endDate.toISOString();

      filter = {
        ...filter,

        onDate: {
          $gte: startDateISOString,
          $lte: endDateISOString,
        },
      };
    }

    const { result } = await invoke({
      id: '_find',
      paramValue: {
        query: {
          id: 'cdkListAll',
          addOnFilter: {
            ...filter,
          },
          limit,
          skip,
          skipAggregates: false,
        },
        model: MODELS.AVFailCount,
      },
    });
    if (result?.length) {
      setData((prevData) => [...prevData, ...result]);
      setDataFound(true);
    } else {
      setData([]);
      setDataFound(false);
    }
  };

  // Handlers for next and previous page navigation
  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
    // setData([]); // Reset data on page change if needed
    // fetch(); // Fetch data for the next page
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
      // setData([]); // Reset data on page change if needed
      // fetch(); // Fetch data for the previous page
    }
  };
  // Refetch data when page changes
  useEffect(() => {
    fetch();
  }, [currentPage]);

  useEffect(() => {
    if (value[0]) {
      if (value[0] && value[1]) {
        console.log('value handler running');
        setData([]); // Reset data before fetching new data
        fetch();
      }
    } else if (value[0] === null && value[1] === null) {
      if (isRender.current) {
        return;
      }
      console.log('value handler running else if');

      setData([]);
      fetch();
    }
  }, [value]);

  useEffect(() => {
    if (isRender.current) {
      isRender.current = false;
      return;
    }
    clearTimeout(delayTimeout.current);
    delayTimeout.current = setTimeout(() => {
      console.log('inputValue changed, fetching data');
      setData([]);
      fetch();
    }, 500);
  }, [inputValue]);

  console.log('F16', data);

  const headCellsData = [
    {
      id: 'index',
      numeric: false,
      disablePadding: false,
      label: '#',
    },
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: 'Name',
    },
    {
      id: 'onDate',
      numeric: false,
      disablePadding: false,
      label: 'Date Generated',
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email',
    },
    {
      id: 'contactNumber',
      numeric: false,
      disablePadding: false,
      label: 'Phone#',
    },
    {
      id: 'vin',
      numeric: false,
      disablePadding: false,
      label: 'VIN',
    },
    {
      id: 'deliveryDate',
      numeric: false,
      disablePadding: false,
      label: 'Last Purchased Date',
    },
    {
      id: 'year',
      numeric: false,
      disablePadding: false,
      label: 'Year',
    },
    {
      id: 'make',
      numeric: false,
      disablePadding: false,
      label: 'Make',
    },
    {
      id: 'model',
      numeric: false,
      disablePadding: false,
      label: 'Model',
    },
    {
      id: 'mileage',
      numeric: false,
      disablePadding: false,
      label: 'Mileage',
    },
    {
      id: 'failedResult',
      numeric: false,
      disablePadding: false,
      label: 'Reason',
    },
  ];

  const [headCells, setHeadCells] = React.useState(headCellsData);

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });

  const extractFailedReasons = (item) => {
    if (item.errorCause === 'Rule failure') {
      const failedDetails = [];
      const failedResult = item.failedResult
        ? JSON.parse(item.failedResult)
        : [];

      failedResult.forEach((result) => {
        result.details.forEach((detail) => {
          if (!detail.Passed) {
            failedDetails.push(`${result.ruleName}: ${detail.Field} - Failed`);
          }
        });
      });

      return failedDetails.join(',');
    }

    return item.errorCause;
  };
  const handleExportData = () => {
    // Customize data array based on columns

    const customizedData = data.map((item) => ({
      Name: item.cdk.name,
      Email: item.cdk.email,
      'Phone#': item.cdk.contactNumber,
      VIN: item.cdk.vin,
      Year: item.cdk.year,
      Make: item.cdk.make,
      Model: item.cdk.model,
      Mileage: item.cdk.mileage,
      'Date Generated#': modifyDateView(item.onDate),
      'Rrror Cause': item.errorCause,
      Reason: extractFailedReasons(item),
    }));

    const csv = generateCsv(csvConfig)(customizedData);
    download(csvConfig)(csv);
  };

  const handleExportRows = () => {
    const rowData = data.filter((item) => selected.includes(item?._id));
    console.log('rowData', rowData);
    const customizedData = rowData.map((item) => ({
      Name: item.cdk.name,
      Email: item.cdk.email,
      'Phone#': item.cdk.contactNumber,
      VIN: item.cdk.vin,
      Year: item.cdk.year,
      Make: item.cdk.make,
      Model: item.cdk.model,
      Mileage: item.cdk.mileage,
      'Date Generated#': modifyDateView(item.onDate),
      'Rrror Cause': item.errorCause,
      Reason: extractFailedReasons(item),
    }));

    console.log('Test', customizedData);

    const csv = generateCsv(csvConfig)(customizedData);
    download(csvConfig)(csv);
  };

  function EnhancedTableHead(props) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              style={{
                marginInline: 'auto',
              }}
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all',
              }}
            />
          </TableCell>
          {headCells.map((headCell, i) => (
            <>
              <TableCell
                key={headCell.id}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
                style={{
                  fontSize: '18px',
                  whiteSpace: 'nowrap',
                  minWidth: 70,
                }}>
                {headCell?.label === '#' ? (
                  <p style={{ textAlign: 'center' }}>{headCell.label}</p>
                ) : (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                    style={{
                      fontSize: '18px',
                      whiteSpace: 'nowrap',
                    }}>
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                )}
              </TableCell>
            </>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIds, setSelectedIds] = useState(
    headCellsData.map((cell) => cell.id),
  );

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        // If already selected, remove it
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        // If not selected, add it
        return [...prevSelectedIds, id];
      }
    });
  };

  React.useEffect(() => {
    // Filter the header cells
    setHeadCells(headCellsData.filter((cell) => selectedIds.includes(cell.id)));

    // Filter the rows data
    const filteredRows = data?.map((obj, index) => {
      console.log('Bro', obj);
      const filteredRow = {};
      selectedIds.forEach((id) => {
        filteredRow.id = obj._id;
        filteredRow.errorCause = obj.errorCause;
        switch (id) {
          case 'index':
            filteredRow.index = index + 1;
            break;
          case 'name':
            filteredRow.name = obj.cdk.name ? obj.cdk.name : 'N/A';
            break;
          case 'onDate':
            filteredRow.onDate = obj.onDate ? obj.onDate : 'N/A';
            break;
          case 'email':
            filteredRow.email = obj.cdk.email ? obj.cdk.email : 'N/A';
            break;
          case 'contactNumber':
            filteredRow.contactNumber = obj.cdk.contactNumber
              ? obj.cdk.contactNumber
              : 'N/A';
            break;
          case 'deliveryDate':
            filteredRow.deliveryDate = obj.cdk.deliveryDate
              ? obj.cdk.deliveryDate
              : 'N/A';
            break;
          case 'vin':
            filteredRow.vin = obj.cdk.vin ? obj.cdk.vin : 'N/A';
            break;
          case 'year':
            filteredRow.year = obj.cdk.year ? obj.cdk.year : 'N/A';
            break;
          case 'make':
            filteredRow.make = obj.cdk.make ? obj.cdk.make : 'N/A';
            break;
          case 'model':
            filteredRow.model = obj.cdk.model ? obj.cdk.model : 'N/A';
            break;
          case 'mileage':
            filteredRow.mileage = obj.cdk.mileage ? obj.cdk.mileage : 'N/A';
            break;
          case 'failedResult':
            filteredRow.failedResult = obj.failedResult
              ? JSON.parse(obj.failedResult)
              : [];
            break;
          default:
            break;
        }
      });
      return filteredRow;
    });

    // Set the filtered rows to state or use them directly
    setFilteredRows(filteredRows);
    console.log('Filtered Rows12:', filteredRows);
  }, [selectedIds, data]);

  function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}>
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={handleExportData}
          startIcon={
            <FileDownloadIcon
              style={{
                fontSize: '1.5rem',
              }}
            />
          }
          style={{
            fontSize: '1.5rem',
          }}
          className="exportButton">
          Export All Data
        </Button>
        {/* <Button
          startIcon={
            <FileDownloadIcon
              style={{
                fontSize: '1.5rem',
              }}
            />
          }
          style={{
            fontSize: '1.5rem',
          }}
          className="exportButton">
          Export All Rows
        </Button> */}
        <Button
          disabled={selected.length === 0}
          //only export selected rows
          onClick={() => handleExportRows(selected)}
          startIcon={
            <FileDownloadIcon
              style={{
                fontSize: '1.5rem',
              }}
            />
          }
          style={{
            fontSize: '1.5rem',
          }}
          className="exportButton">
          Selected Rows
        </Button>
      </Box>
    );
  }

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    console.log('Test 2', filteredRows);
    if (event.target.checked) {
      const newSelected = filteredRows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleRowSelection = (id) => {
    console.log('selected', selected);
    if (selected.includes(id)) {
      setSelected(selected.filter((item) => item !== id));
    } else {
      setSelected((prev) => [...prev, id]);
    }
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    currentPage > 0
      ? Math.max(0, (1 + currentPage) * rowsPerPage - filteredRows.length)
      : 0;

  const visibleRows = React.useMemo(() => {
    let test = stableSort(filteredRows, getComparator(order, orderBy));
    let x = test.slice(
      currentPage * rowsPerPage,
      currentPage * rowsPerPage + rowsPerPage,
    );
    console.log('TOST', test);
    return x;
  }, [order, orderBy, currentPage, rowsPerPage, filteredRows]);

  console.log('Visible rows', filteredRows);

  // useEffect(() => {
  //   if (data.length === 0) {
  //     setIsLoading(true);
  //   } else {
  //     setIsLoading(false);
  //   }
  //   // setIsLoading(true);
  // }, [data, setData]);

  const { headings } = vars;

  const textStyle = { ...headings.pageHeading, marginLeft: 12 };

  const {
    searchContainerStyle,
    inputStyle,
    searchImageStyle,
    crossImageStyle,
  } = ftsThemeMD;

  return (
    <>
      <div
        className="d-block d-sm-flex p-md-1"
        style={{ justifyContent: 'between' }}>
        <Text className="mt-md-3" style={textStyle}>
          Appraisals Failed List
        </Text>

        <div style={{ marginLeft: 'auto' }} className="ps-3 ps-md-0 mb-md-2">
          {!view ? (
            <div className="d-flex align-items-center">
              <View style={{ ...searchContainerStyle, marginTop: '0.6rem' }}>
                <input
                  type="search"
                  style={inputStyle}
                  placeholder={'Search by Appraisal#/VIN/Mobile/Email'}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                  }}
                />
              </View>
              <div className="ps-md-1">
                <Calender value={value} setValue={setValue} />
              </div>
            </div>
          ) : (
            <ViewButtonsLists id={id} setView={setView} avgen={true} />
          )}
        </div>
      </div>
      <Box sx={{ width: '100%', maxHeight: '100%', border: 'none' }}>
        <div sx={{ width: '100%', border: 'none' }}>
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              <EnhancedTableToolbar numSelected={selected.length} />
              <div>
                <Button style={{ fontSize: 13 }} onClick={handleMenuOpen}>
                  Filter Columns
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  style={{
                    gap: 0,
                    fontSize: 12,
                  }}>
                  {headCellsData.map((cell) => (
                    <MenuItem key={cell.id} style={{ fontSize: 12 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            style={{
                              padding: 0,
                              paddingRight: 5,
                            }}
                            checked={selectedIds.includes(cell.id)}
                            onChange={() => handleCheckboxChange(cell.id)}
                          />
                        }
                        label={cell.label}
                      />
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            </div>

            {isLoading ? (
              <div
                className="tableBoxHeight"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <div class="loader12"></div>
              </div>
            ) : (
              <>
                {!dataFound ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                    }}
                    className="tableBoxHeight">
                    <p
                      style={{
                        fontSize: '16px',
                        fontWeight: 'normal',
                      }}>
                      Data not found...
                    </p>
                  </div>
                ) : (
                  <TableContainer
                    style={{
                      height: 460,
                      position: 'relative',
                    }}
                    className="tableBoxHeight">
                    <Table
                      sx={{ minWidth: 750 }}
                      aria-labelledby="tableTitle"
                      size={'medium'}>
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={filteredRows.length}
                      />
                      <TableBody
                        style={{
                          maxHeight: '500px',
                          overflowY: 'auto',
                        }}>
                        {visibleRows.map((row, index) => {
                          const isItemSelected = selected.includes(row.id);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              key={row.id}
                              selected={isItemSelected}
                              sx={{ cursor: 'pointer' }}>
                              <TableCell padding="checkbox">
                                <Checkbox
                                  color="primary"
                                  checked={isItemSelected}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={() => {
                                    handleRowSelection(row.id);
                                  }}
                                  inputProps={{
                                    'aria-labelledby': labelId,
                                  }}
                                />
                              </TableCell>
                              {row.index && (
                                <TableCell
                                  component="th"
                                  id={labelId}
                                  scope="row"
                                  padding="none">
                                  <p
                                    style={{
                                      fontSize: '16px',
                                      width: '100%',
                                      textAlign: 'center',
                                    }}>
                                    {row.index}
                                  </p>
                                </TableCell>
                              )}
                              {row.name && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.name}
                                </TableCell>
                              )}
                              {row.onDate && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {modifyDateView(row.onDate || ' ')}
                                </TableCell>
                              )}

                              {row.email && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.email}
                                </TableCell>
                              )}
                              {row.contactNumber && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.contactNumber}
                                </TableCell>
                              )}
                              {row.vin && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.vin}
                                </TableCell>
                              )}
                              {row.deliveryDate && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {!row.deliveryDate
                                    ? ''
                                    : row.deliveryDate === 'Never Purchased' ||
                                      row.deliveryDate ===
                                        '1970-01-01T00:00:00.000Z'
                                    ? 'Never Purchased'
                                    : modifyDateView(row.deliveryDate)}
                                </TableCell>
                              )}
                              {row.year && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.year}
                                </TableCell>
                              )}
                              {row.make && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.make}
                                </TableCell>
                              )}
                              {row.model && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.model}
                                </TableCell>
                              )}

                              {row.mileage && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {row.mileage}
                                </TableCell>
                              )}

                              {row.failedResult && (
                                <TableCell
                                  align="left"
                                  sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                  {(() => {
                                    let failedResult = row.failedResult;

                                    // Only parse if it's a string
                                    if (typeof failedResult === 'string') {
                                      failedResult = JSON.parse(failedResult);
                                    }

                                    const failedDetails = failedResult.reduce(
                                      (acc, result) => {
                                        const failed = result.details.filter(
                                          (detail) => !detail.Passed,
                                        );
                                        if (failed.length > 0) {
                                          acc.push({
                                            ruleName: result.ruleName,
                                            details: failed,
                                          });
                                        }
                                        return acc;
                                      },
                                      [],
                                    );

                                    return (
                                      <div
                                        style={{
                                          fontSize: 16,
                                          textAlign: 'left',
                                        }}>
                                        {row.errorCause === 'Rule failure'
                                          ? failedDetails.map(
                                              (failedResult, index) => (
                                                <div key={index}>
                                                  <p>
                                                    <strong>Rule Name:</strong>{' '}
                                                    {failedResult.ruleName}
                                                  </p>
                                                  {failedResult.details.map(
                                                    (detail, idx) => (
                                                      <p key={idx}>
                                                        {detail.Field ===
                                                        'Range'
                                                          ? 'Mileage Range'
                                                          : detail.Field}
                                                        : Failed
                                                      </p>
                                                    ),
                                                  )}
                                                </div>
                                              ),
                                            )
                                          : row.errorCause}
                                      </div>
                                    );
                                  })()}
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}>
                            <TableCell colSpan={6}></TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                gap: 10,
                paddingTop: 8,
                paddingRight: 15,
              }}>
              <button
                className="paginationBtn"
                onClick={handlePrevPage}
                disabled={currentPage === 0}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-chevron-left">
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>
              <button className="paginationBtn" onClick={handleNextPage}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-chevron-right">
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>
            </div>
          </>
        </div>

        {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
      </Box>
    </>
  );
}
